import { Entity, Group, User } from '../types';

export const DefaultAppViewPropertyId = 'global';

export const NoAppViewPropertyValueOnServer = '';

export enum AppViewPropertyKey {
  OutlookPublisherGuideOpen = 'user.storyline.outlookPublisherGuideOpen',
  StorylinePageVisited = 'user.storyline.storylinePageHasBeenVisited',
  StorylineCongratulationsTeachingBubbleStatus = 'user.storyline.congratulationsTeachingBubbleStatus',
  StorylineSuggestedMediaCoachingTip = 'user.storyline.suggestedMediaCoachingTip',
  StorylineSuggestedMentionsCoachingTip = 'user.storyline.suggestedMentionsCoachingTip',
  CMSubscriptionTip = 'group.actionTips.CMSubscriptionTip',
  CMSubscriptionTeachingBubble = 'group.teachingBubbles.CMSubscriptionTeachingBubble',
  GroupAvatarTeachingBubble = 'group.teachingBubbles.GroupAvatarTeachingBubble',
  GroupCoverPhotoTeachingBubble = 'group.teachingBubbles.GroupCoverPhotoTeachingBubble',
  GroupDescriptionTeachingBubble = 'group.teachingBubbles.GroupDescriptionTeachingBubble',
}

export type StorylineCoachingTipTypes =
  | AppViewPropertyKey.StorylineSuggestedMediaCoachingTip
  | AppViewPropertyKey.StorylineSuggestedMentionsCoachingTip;

export interface StorylinePageVisitedAppViewProperty {
  readonly visited: boolean;
}

export interface OutlookPublisherGuideOpenAppViewProperty {
  readonly isOpen: boolean;
}

export interface StorylineCoachingTipAppViewProperty {
  readonly lastDisplayed: number;
}

export enum StorylineCongratulationsTeachingBubbleStatus {
  ReadyToShow = 'ReadyToShow',
  Showing = 'Showing',
  Hide = 'Hide',
}
export interface StorylineCongratulationsTeachingBubbleStatusAppViewProperty {
  readonly status: StorylineCongratulationsTeachingBubbleStatus;
}

export interface SubscriptionTipAppViewProperty {
  readonly isDismissed: boolean;
  readonly remindMeLater: boolean;
  readonly remindMeLaterClickedDate: number | null;
}

export interface SubscriptionTeachingBubbleAppViewProperty {
  readonly isDismissed: boolean;
}

export interface GroupTeachingBubbleAppViewProperty {
  readonly isDismissed: boolean;
  readonly date: number | null;
}

export type AppViewPropertyJSON =
  | OutlookPublisherGuideOpenAppViewProperty
  | SubscriptionTipAppViewProperty
  | SubscriptionTeachingBubbleAppViewProperty
  | GroupTeachingBubbleAppViewProperty
  | StorylinePageVisitedAppViewProperty
  | StorylineCongratulationsTeachingBubbleStatusAppViewProperty
  | StorylineCoachingTipAppViewProperty;

export interface AppViewProperty extends Entity {
  readonly id: Group['id'] | User['id'] | typeof DefaultAppViewPropertyId;
  readonly key: AppViewPropertyKey;
  readonly value: unknown | null;
}

export type AppViewPropertiesEntityMap = Record<string, AppViewProperty>;

export type AppViewProperties = Partial<Record<AppViewPropertyKey, AppViewPropertiesEntityMap>>;

export const defaultSubscriptionTipAppViewProperty: SubscriptionTipAppViewProperty = {
  isDismissed: false,
  remindMeLater: false,
  remindMeLaterClickedDate: null,
};

export const defaultSubscriptionTeachingBubbleProperty: SubscriptionTeachingBubbleAppViewProperty = {
  isDismissed: false,
};

export const defaultGroupTeachingBubbleAppViewProperty: GroupTeachingBubbleAppViewProperty = {
  isDismissed: false,
  date: null,
};

const defaultStorylinePageVisitedProperty: StorylinePageVisitedAppViewProperty = { visited: true };
const defaultOutlookPublisherGuideOpen: OutlookPublisherGuideOpenAppViewProperty = { isOpen: true };
const defaultStorylineCongratulationsTeachingBubbleProperty: StorylineCongratulationsTeachingBubbleStatusAppViewProperty =
  {
    status: StorylineCongratulationsTeachingBubbleStatus.Hide,
  };

const defaultStorylineSuggestedCoachingTip: StorylineCoachingTipAppViewProperty = { lastDisplayed: 0 };

export const defaultAppViewProperties: Record<AppViewPropertyKey, AppViewPropertyJSON> = {
  [AppViewPropertyKey.OutlookPublisherGuideOpen]: defaultOutlookPublisherGuideOpen,
  [AppViewPropertyKey.StorylinePageVisited]: defaultStorylinePageVisitedProperty,
  [AppViewPropertyKey.StorylineCongratulationsTeachingBubbleStatus]:
    defaultStorylineCongratulationsTeachingBubbleProperty,
  [AppViewPropertyKey.StorylineSuggestedMediaCoachingTip]: defaultStorylineSuggestedCoachingTip,
  [AppViewPropertyKey.StorylineSuggestedMentionsCoachingTip]: defaultStorylineSuggestedCoachingTip,
  [AppViewPropertyKey.CMSubscriptionTip]: defaultSubscriptionTipAppViewProperty,
  [AppViewPropertyKey.CMSubscriptionTeachingBubble]: defaultSubscriptionTeachingBubbleProperty,
  [AppViewPropertyKey.GroupAvatarTeachingBubble]: defaultGroupTeachingBubbleAppViewProperty,
  [AppViewPropertyKey.GroupCoverPhotoTeachingBubble]: defaultGroupTeachingBubbleAppViewProperty,
  [AppViewPropertyKey.GroupDescriptionTeachingBubble]: defaultGroupTeachingBubbleAppViewProperty,
};
